<template>
    <div class="publicViewClass" style="padding-top:0">
        <div class="edit-step">
            <topicSteps :active = "3" :propList="propList"></topicSteps>
        </div>
        <div id="editPaper" class="app-inner">
             <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="reback">
            上一步
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="SavePush"
            >
             保存并发布
           </el-button>
            </div>
            <!-- 试卷设置 -->
            <div class="setting-content">
                <div class="list-box">
                    <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">有效期限</p>
                        </div>
                        <div class="settings-box-radio flex align-cen">
                            <span class="settings-box-radio-tit">当前：</span>
                             <el-radio v-model="list.validPeriod" label="2">永久有效</el-radio>
                        </div>
                    </div>
                    <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">答卷次数</p>
                        </div>
                        <div class="settings-box-radio flex align-cen">
                             <el-radio v-model="list.answerNumType" label="0">无限次</el-radio>
                        </div>
                    </div>
                     <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">答题时间控制</p>
                        </div>
                        <div class="settings-box-radio settings-box-radio1">
                             <el-radio v-model="list.answerTimeControl" label="1">
                                独立时间
                                <span class="set-exam-time">答卷时长:</span>
                                <el-input  placeholder="请输入内容" v-model="list.answerTimeLimit" clearable maxlength="3" 
                                class="setting-default-input"
                                @input="numValid('answerTimeLimit')"
                                >
                                </el-input>
                                <span>分钟</span>
                                <span class="hint">
                                    (在规定的开放时间内，考生无论何时进入答题，都不影响答卷时长，且设置为0表示不限时长。)
                                </span>
                             </el-radio>
                        </div>
                          <div class="settings-box-radio settings-box-radio1">
                             <el-radio v-model="list.answerTimeControl" label="3">
                                单题时间设置
                                <el-input  placeholder="请输入值（1-100）" v-model="list.singleDuration" clearable maxlength="3" 
                                class="setting-default-input"
                                  @input="numValid('singleDuration')"
                                >
                                </el-input>
                                <span>分钟</span>
                             </el-radio>
                        </div>
                        <div class="settings-box-radio settings-box-radio1">
                             <span class="" >最短交卷时间:</span>
                            <el-input  placeholder="请输入内容" v-model="list.minTakenTime" clearable maxlength="3"  @input="numValid('minTakenTime')" class="setting-default-input"></el-input>
                             <span>分钟</span>
                             <span class="hint">
                                    (留空表示不限时间。)
                                </span>
                        </div>
                    </div>
                    <div class="settings-box">
                        <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">考试说明</p>
                        </div>
                         <div class="settings-box-radio flex align-cen">
                             <el-radio v-model="list.showGuidelines" label="1">只显示默认说明</el-radio>
                        </div>
                        <div class="settings-box-radio">
                            <div class="default-guidelines">
                                <p class="flex align-cen">
                                    <span class="span1">考试次数：</span>
                                    <span class="mft span2">{{shouInfo(list.answerNumType,list.answerNum,1)}}</span>
                                </p>
                                    <p class="flex align-cen">
                                    <span class="span1">考试限时：</span>
                                    <span class="mft span2">{{shouInfo(list.answerTimeControl,'',2)}}</span>
                                </p>
                                <p class="flex align-cen">
                                    <span class="span1">及格分数：</span>
                                    <span class="mft span2"> {{shouInfo(0,list.passmark,3)}}</span>
                                </p>
                                <p class="flex align-cen">
                                    <span class="span1">考试规则：</span>
                                    <span class="mft span2">{{shouInfo(list1.allowBackChange,'',4)}}</span>
                                </p>
                                <p>
                                    <span class="span3">若考试异常中断，请退出并及时按同样步骤进入，继续考试。</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="settings-box">
                             <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">显示说明</p>
                        </div>
                         <!-- <div class="settings-box-radio flex align-cen">
                            <el-input  
                            placeholder="请输入" v-model="list.questionPerPage"  
                            class="setting-default-input" type="number" min="1" max="100"
                            @input="ChageautoSkip"
                            ></el-input>
                            <span>题/页</span>
                        </div> -->
                       <div class="settings-box-radio " style="margin-top:16px">
                           <el-radio v-model="list.watermark" label="1">是否开启试卷水印</el-radio >
                        </div>
                    </div>
                    <div class="settings-box">
                         <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">答题规则</p>
                        </div>
                        <div class="field-group flex" v-if="list.answerTimeControl != 3">
                            <span class="form-field-title">
                                强制性
                            </span>
                            <div class="form-check">
                                  <el-checkbox-group v-model="list1.mandatory">
                                     <el-checkbox label="1" >
                                        必须回答完所有试题才能交卷<span>（答卷者必须回答完所有题目，才可以交卷，除非已到考试时间）</span>
                                     </el-checkbox>
                                    <el-checkbox label="2">
                                        答对后才能继续回答下一题<span>（答卷者要求回答正确每一题，才能进行下一题. 否则答卷将结束）</span>
                                    </el-checkbox>
                                  </el-checkbox-group>
                            </div>
                        </div>
                         <div class="field-group flex">
                            <span class="form-field-title">
                                练习模式
                            </span>
                            <div class="form-check">
                                 <el-radio-group v-model="list.practiceMode">
                                <el-radio label="0">不开启</el-radio>
                                <el-radio label="1">每答完一题立即查看答案与解析</el-radio>
                                <el-radio label="2">只在达错时显示答案与解析</el-radio>
                                 </el-radio-group>
                            </div>
                         </div>
                          <div class="field-group flex" v-if="list.answerTimeControl != 3">
                            <span class="form-field-title">
                                改变答案
                            </span>
                            <div class="form-check">
                                 <el-checkbox-group v-model="list1.allowBackChange">
                                <el-checkbox label="1" >允许考生返回修改答案
                                     </el-checkbox>
                                 </el-checkbox-group >
                            </div>
                         </div>
                             <div class="field-group flex">
                            <span class="form-field-title">
                                漏选得分
                            </span>
                            <div class="form-check">
                                 <el-checkbox-group v-model="list1.regressionScore">
                                <el-checkbox label="1" >允许多选题漏选按比例得分<span>（例正确答案为ABC，满分为3分，考生只选了AB，按比例可得2分）</span>
                                     </el-checkbox>
                                 </el-checkbox-group >
                            </div>
                         </div>
                    </div>
                     <div class="settings-box">
                         <div class="settings-box-tips flex align-cen">
                            <div class="red-div"></div>
                            <p class="red-div-p">评语设置</p>
                        </div>
                          <div class="settings-box-radio settings-box-radio1">
                                <span class="set-exam-time">及格分数:</span>
                                <el-input  placeholder="请输入内容" v-model="list.passmark" clearable maxlength="3"
                                @input="numValid('passmark')"
                                 class="setting-default-input"></el-input>
                                <span>
                                    %
                                </span>
                        </div>
                         <div class="settings-box-radio settings-box-radio1">
                              <el-radio v-model="list.commentSet" label="1">及格评语 </el-radio>
                             <el-radio v-model="list.commentSet" label="2">分数段评语</el-radio>
                         </div>
                         <!-- 固定分数 -->
                         <div class="settings-box-radio" v-if="list.commentSet == 1">
                               <div class="AppContent">
                                <div class="moreCanvas"
                                    v-for="(item,index) in commentList"
                                    :key="index"
                                    :id="'addCanvas'+index"
                                    >
                                        <div class="public-tit flex align-cen" style="margin-bottom:20px">
                                        <div class="public-tit-list">
                                            <i class="icon-al-database-fill"></i>
                                            {{index == 0 ? '及格评语：' : '不及格评语：'}}
                                        </div>
                                    </div>
                                    <quillsTemplate  @sendStatus="emitFun" 
                                    :propData="item.comments"
                                    :currindex="index"
                                    :tempname="index"
                                    :placeName="'评语'"
                                    :ref="'quillTemplate' + index"
                                    ></quillsTemplate>
                                </div>
                            </div>
                         </div>
                         <!-- 分数段 -->
                          <div class="settings-box-radio" v-if="list.commentSet == 2">
                            <div class="form-group">
                                <div class="slider-comments" @mouseleave="isAmdh = false">
                                    <div class="slider-wrap" >
                                        <div class="score-slider"  ref="myDiv"   
                                          @mouseover="showWidth"
                                        >
                                            <span class="min">0%</span>
                                            <span class="max">100%</span>
                                        </div>
                                        <p></p>
                                        <div class="handle-hint bounce-transition" :data-title='`在分数${boxWidthPercent}%处插入分数段`'
                                        :style="{left:width + 'px',display:isAmdh ? 'block' : 'none'}"
                                        @click="insertNum"
                                        >
                                        </div>
                                        <div class="slider-handle bounce-transition" 
                                        v-for="(item,index) in slideClik" 
                                        :data-value='`${item}`'
                                        :style="{left:item + '%'}"
                                         @click="cacelInser(item,index)"
                                        >

                                        </div>
                                    </div>
                                </div> 
                            </div>
                             <div class="AppContent" style="margin-top:20px">
                                  <div class="moreCanvas"
                                    v-for="(item,index) in resultList"
                                    :key="index"
                                    :id="'addCanvas'+index"
                                    >
                                        <div class="public-tit flex align-cen" style="margin-bottom:20px">
                                        <div class="public-tit-list">
                                            <i class="icon-al-database-fill"></i>
                                            分数段：{{item.segment}}(单位：%)
                                        </div>
                                    <div class="mft public-btn-small" v-if="index!=0" @click="cacelInser(item,index,'tem')">
                                        <div class="public-btn-small-primary" >
                                            删除     
                                        </div>
                                    </div>
                                    </div>
                                    <quillsTemplate  @sendStatus="emitFun1" 
                                    :propData="item.comments"
                                    :currindex="index"
                                    :tempname="index"
                                    :placeName="'此分段评语'"
                                    :ref="'quillTemplate' + index"
                                    ></quillsTemplate>
                                </div>
                             </div>
                            <!-- <el-slider
                            v-model="value"
                            range
                            :marks="marks"
                            :max="100"
                            @change="sliderEdit"
                            >
                            </el-slider> -->
                          </div>
                     </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import topicSteps from "@/components/topicSteps/index.vue"; //步骤条组件
import quillsTemplate from "@/components/quills";  //多富文本组件
import debounce from '../../../../utils/debounce.js' //防抖
import {getPaper,getComments,editPapeItem} from "@/api/index/index"   //获取试卷详情 、获取评分列表、修改试卷
export default {
    name:'threeIndex',
     components: {
        topicSteps,
        quillsTemplate
    },
    data () {
        return {
            resultList:[
              {
                    "segment":'0-100',
                    "comments":''
                }
            ],
            slideClik:[],
            isAmdh:true,
             width:323.5,
                commentList:[
                {
                    "segment":'60-100',
                    "comments":''
                },{
                   "segment":'0-59',
                   "comments":'' 
                }
               ],
            isAutoSkip:true,
            list:{},
            list1:{
               allowBackChange:[],
               mandatory:[],
               autoSkip:"",
               regressionScore:[],
               practiceMode:'0',
               passmark:60,
               validPeriod:'2',
               answerNumType:'0',
               answerTimeControl:'1',
               answerTimeLimit:'30',
               singleDuration:'5',
               minTakenTime:'0',
               showGuidelines:'1',
               questionPerPage:'1',
               commentSet:'2',
            },
            loading:false,
               propList:[
            {
                steps:1,
                text:'基本信息',
            },
            {
                steps:2,
                text:'添加试题',
            },{
                steps:3,
                text:'试卷设置',
            },{
                steps:4,
                text:'完成', 
            }

                ]
        }
    },
    computed: {  
    boxWidthPercent() {  
    let num = Math.round((this.width / 647) * 100) < 100 ? Math.round((this.width / 647) * 100) : 100
    return num;   
    }  
  },
    created () {
     this.getPaperDetail()
    },
    methods: {
        // 根据条件显示不同
        shouInfo(type,num,fnType){
            // fnType = 1 表示考试次数、 2、表示考试限时
            const actionTypelanes = {
                0:fnType == 1 ? '无限次': fnType == 3 ? `${num}%`: '-',
                1:fnType == 1 ? '一次' : fnType == 2 ? `${this.list.answerTimeLimit}分钟` : fnType == 4 ? '允许考生返回修改答案' : '',
                2:fnType == 1 ? `多次（${num}次）` : fnType == 2 ? '' : '',
                3:fnType == 1 ? `每天每人（${num}）次` : fnType == 2 ? `单题${this.list.singleDuration}分钟` : '',
                4:fnType == 1 ? '' : fnType == 2 ? '填空题' : ''
            }
            return actionTypelanes[type] || '-'
        },
        numValid(inputContent) {
   var reg = /^([1-9]\d{0,2})$/;
   if(reg.test(this.list[inputContent])==false){
        this.list[inputContent] = "";
        return false;
   }else{
       this.list[inputContent] = this.list[inputContent];
   }
 },
                // 保存并发布
        SavePush(){
              if(!this.list.validPeriod) return this.$util.Notifi('请选择试卷有效期限','error','fa-exclamation-circle')
             if(!this.list.answerNumType) return this.$util.Notifi('请选择答卷次数类型','error','fa-exclamation-circle')
              if(!this.list.answerTimeControl) return this.$util.Notifi('请选择答卷时间','error','fa-exclamation-circle')
                               if(this.list.answerTimeControl == 3){
                                        this.list1.allowBackChange = []
                                        this.list1.mandatory = []
                    }
                                if(this.list1.mandatory.includes('2')){
                      if( this.list1.allowBackChange.includes('1')){
                        return this.$util.Notifi('强制性规则与改变答案规则互斥，请重新选择','error','fa-exclamation-circle')
                      }
                    }
            this.list.mandatory = this.list1.mandatory.length > 0  ? this.list1.mandatory.join(',') : ''
         this.list.allowBackChange = this.list1.allowBackChange.length > 0 ? this.list1.allowBackChange.join(',') : ''
         this.list.regressionScore = this.list1.regressionScore.length > 0 ? this.list1.regressionScore.join(',') : ''
          if(this.list.state){
            delete this.list.state; 
         }
        //  this.list.allowBackChange = this.list.allowBackChange.length > 0 ? this.list.allowBackChange.join(',') : ''
        //  this.list.regressionScore = this.list.regressionScore.length > 0 ? this.list.regressionScore.join(',') : ''
      
         if(this.list.commentSet == '1'){
            this.list.commentList = this.commentList
         }else{
            this.list.commentList = this.resultList
         }
         this.loading = true
         editPapeItem({...this.list,id:this.$route.query.threeId},'put')
         .then(res =>{
            this.loading = false
            if(res.code == 0){
                 this.$util.Notifi('保存成功','success','fa-check')
                     setTimeout(() => {this.$router.push('/testPapeList')}, 100);
            }else{
               this.$util.Notifi(res.msg,'error','fa-exclamation-circle') 
            }
         })
         .catch(err =>{
            this.loading = false
            this.$util.Notifi('修改失败','error','fa-exclamation-circle')
         })
        },
     
        // 获取评分列表
        getCommentsList(){
            getComments({id:this.$route.query.threeId})
            .then(res =>{
                if(res.data.length){
                if(this.list.commentSet == '1'){
                    this.commentList = res.data
                }else{
                    this.isAmdh = false
                    this.resultList = res.data
                    let arr = []
                    for (let key in res.data) {
                        arr.push(res.data[key].segment)
                    }
                    this.outShow(arr)
                }
                }
            })
        },
           // slider回显
        outShow(ranges){
            var result = [];  
                        // 遍历每个范围字符串  
            for (var i = 0; i < ranges.length; i++) {  
            // 拆分字符串以获取最小值和最大值  
            var minMax = ranges[i].split('-');  
            
            // 提取最小值和最大值作为字符串并将其转换为数字  
            var minValue = parseInt(minMax[0], 10);  
            var maxValue = parseInt(minMax[1], 10);  
            
            // 计算范围中的最大值并将结果添加到结果数组中 
            if(maxValue !=100){
                 result.push(maxValue);  
            } 
            }  
            this.slideClik = result
            // console.log(result);
        },
          // 获取试卷详情
        getPaperDetail(){ 
            getPaper({id:this.$route.query.threeId},'get')
            .then(res =>{
              this.list = res.data
              if(!this.list.practiceMode){
                this.list.practiceMode = '0' 
              }
              if(!this.list.validPeriod) this.list.validPeriod = '2'
               if(!this.list.answerNumType) this.list.answerNumType = '0'
                if(!this.list.questionPerPage) this.list.questionPerPage = '1'
              if(!this.list.passmark) this.list.passmark = '60'
               if(!this.list.showGuidelines) this.list.showGuidelines = '1'
               if(!this.list.watermark) this.list.watermark = '1'
                this.getCommentsList()
                      if(res.data.mandatory){
                this.list1.mandatory = res.data.mandatory.split(',')
              }
               if(res.data.allowBackChange) {
                this.list1.allowBackChange = res.data.allowBackChange.split(',')
              } 
               if(res.data.regressionScore) {
                this.list1.regressionScore = res.data.regressionScore.split(',')
              } 
            //  for (let key in this.list) {
            //    for (let i in this.list1) {
            //    if(key == i){
            //     if(!this.list[key]){
            //       this.list[key] = this.list1[key]
            //     }
            //    }
            //    }
            //  }
            //   if(res.data.allowBackChange) {
            //     this.list.allowBackChange = res.data.allowBackChange.split(',')
            //   } 
                         
            })
            .catch(err =>{})
        },
        splitArray(numbers) {  
   const result = [];  
  let startValue = 0;  
  let endValue = 0;  
  const length = numbers.length;  
    
  // 处理只有一个元素的情况  
  if (length === 1) {  
    result.push(startValue + '-' + numbers[0]);  
      result.push(parseInt(Number(numbers[0]) + 1) + '-' + 100);  
    return result;  
  }  
    
  for (let i = 0; i < length; i++) {  
    const num = numbers[i];  
      
    // 处理第一个元素  
    if (i === 0) {  
      startValue = 0;  
      endValue = num;  
      result.push(startValue + '-' + endValue);  
    } else if (num > endValue) {  
      startValue = endValue;  
      endValue = num;  
      result.push(parseInt(Number(startValue) + 1) + '-' + endValue);  
    } else if (num === endValue) {  
      result.push(parseInt(Number(startValue) + 1) + '-' + endValue);  
      if (i === length - 1) {  
        endValue = 100;  
        result.push(parseInt(Number(startValue) + 1) + '-' + endValue);  
      }  
    } else {  
      result[result.length - 1] += ' ' + num;  
    }  
  }  
    
  // 添加最后一个范围，如果有必要的话  
  if (endValue < 100) {  
    result.push(parseInt(Number(endValue) + 1) + '-' + 100);  
  } 
    
  return result;  
},
        // 点击插入数字
        insertNum(){
            this.isAmdh = false
            this.slideClik.push(this.boxWidthPercent)
            this.slideClik.sort((a, b) => a - b);  
            const result = this.splitArray(this.slideClik);  
            let arr = []
            for (let key in result) {
                arr.push(
                    {
                     segment: result[key],
                     comments:''
                    }
                )
            }
           this.resultList = arr

        },
         // 取消插入
        cacelInser(data,index,type){
            let fidd
            type ? fidd = this.slideClik[index-1] : fidd = data
            let array = this.slideClik.filter(item => item !== fidd);
            this.slideClik = array
            let result = []
            if(this.slideClik.length){
              this.slideClik.sort((a, b) => a - b);  
             result = this.splitArray(this.slideClik);  
            }else{
                result = ['0-100']
            }
            console.log(result)
            let arr = []
            for (let key in result) {
                arr.push(
                    {
                     segment: result[key],
                     comments:''
                    }
                )
            }
           this.resultList = arr
        },
        // 获取滚动条宽度
        showWidth(event){
            // 防抖
         this.isAmdh = true
        this.width = event.offsetX;  
        },
            // 子组件触发的方法
        emitFun(val,i,name){
        this.commentList[i].comments = val
        },
           // 子组件触发的方法
        emitFun1(val,i,name){
        this.resultList[i].comments = val
        },
        // 没题几页input发生改变时
        ChageautoSkip(){
               var reg = /^(1|([1-9]\d{0,1})|100)$/;
                if(reg.test(this.list.questionPerPage)==false){
                        this.list.questionPerPage = "";
                        return false;
                }else{
        if(this.list.questionPerPage > 1){
            this.list.autoSkip = ""
            this.isAutoSkip = false
           }else{
            this.isAutoSkip = true
           }
   }
        },
    // 返回
    reback(){
        this.$router.push({
            name:'twoIndex',
            query:{
                twoId:this.$route.query.threeId
            }
            })
    },
    }
}
</script>
<style lang="scss" scoped>
.setting-content{
    padding: 24px 16px;
    .list-box{
        .settings-box{
            margin-bottom: 48px;
            .settings-box-tips{
                margin-bottom: 20px;
                .red-div{
                    width: 4px;
                    height: 15px;
                    background-color: #409eff;
                    margin-right: 5px;
                }
                .red-div-p{
                 font-size: 16px;
                letter-spacing: 0px;
                color: #333333!important;
                height: unset;
                font-weight: 700;
                }
            }
        }
        .field-group{
           .form-field-title{
            text-align: left;
            width: 68px;
            margin-top: 0;
            height: 15px;
            font-size: 14px;
            font-weight: normal;
            color: #333333;
            margin-left: 13px;
           }
           .form-check{
            margin-left: 20px;
           }
        }
        .form-group{
            .slider-comments{
                width: 647px;
                padding: 0px 50px 20px 40px;
             .slider-wrap{
                 position: relative;
                 padding: 30px 0 10px 5px;
                 .score-slider{
                    background-color: #e4e6e9;
                    border: 1px solid #e4e6e9;
                    height: 4px;
                    border-radius: 4px !important;
                    position: relative;
                    cursor: pointer;
                    span{
                        position: absolute;
                        display: inline-block;
                        line-height: 1px;
                        font-weight: bold;
                        color: #42ca8e;
                        min-width: 20px;
                    }
                    .min{
                         left: -30px;
                        text-align: right;
                    }
                    .max{
                    right: -35px;
                    text-align: left;
                    }
                 }
                 .handle-hint {
                    position: absolute;
                        z-index: 20;
                        display: block;
                        width: 14px;
                        height: 14px;
                        margin-left: -7px;
                        background-color: #009ee7;
                        border-radius: 14px !important;
                        top: 25px;
                        cursor: pointer;
                 }
                 .handle-hint:hover{
                    display: block !important;
                 }
                  .handle-hint::before{
                        content: attr(data-title);
                        display: inline-block;
                        text-align: center;
                        margin-top: 20px;
                        min-width: 100px;
                        margin-left: -43px;
                        font-size: 13px;
                        white-space: nowrap;
                        color: #009ee7;
                  }
                  .handle-hint::after{
                        display: inline-block;
                            font: normal normal normal 14px/1 FontAwesome;
                            font-size: inherit;
                            text-rendering: auto;
                            -webkit-font-smoothing: antialiased;
                            -moz-osx-font-smoothing: grayscale;
                            content: '\f063';
                            color: #009ee7;
                            position: absolute;
                            top: -40px;
                            animation: myAnimation 2s cubic-bezier(0.3, 2.4, 0.85, 2.5) infinite;
                  }
                  .slider-handle{
                    position: absolute;
                    display: block;
                    cursor: pointer;
                    background-color: #55cf99;
                    width: 14px;
                    height: 14px;
                    top: 25px;
                    margin-left: -7px;
                    border-radius: 14px !important;
                    transition: all 0.15s ease-in-out;
                    z-index: 10;
                  }
                  .slider-handle::after{
                    content: attr(data-value);
                    width: 30px;
                    height: 30px;
                    line-height: 30px;
                    position: absolute;
                    top: -40px;
                    left: -8px;
                    display: block;
                    background-color: #42ca8e;
                    text-align: center;
                    color: #fff;
                    border-radius: 30px;
                  }
                  .slider-handle::before{
                        content: ' ';
                        width: 0;
                        height: 0;
                        display: block;
                        border-left: 11px solid transparent;
                        border-right: 11px solid transparent;
                        border-top: 11px solid #42ca8e;
                        position: absolute;
                        left: -4px;
                        top: -15px;
                        z-index: 11;
                  }
             }   
            }
        }
         .settings-box-radio1{
            margin-bottom: 20px;
         }
        .settings-box-radio{
            padding-left: 12px;
            .default-guidelines{
                border-radius: 10px !important;
                border: solid 1px #36aafd;
                padding: 20px 28px;
                margin: 20px 0;
                max-width: 400px;
                p:nth-of-type(-n+4){
                 margin-bottom: 16px;
                }
                       .span1{
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 27px;
                    letter-spacing: 0px;
                    color: #666666;
                 }
                 .span2{
                    height: 17px;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 27px;
                letter-spacing: 0px;
                color: #333333;
                 }
                             .span3{
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #999999;
                 }
            }
            .set-exam-time{
                margin-left: 19px;
                font-weight: 400;
            }
            .hint{
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #999999;
                margin-left: 10px;
            }
        }
    }
}
        @keyframes myAnimation{
            0%{
                transform: translateY(15px) scaleY(0.98);
            }
            80%{
                transform: translateY(12px) scaleY(1.02);
            }
            100%{
                transform: translateY(15px) scaleY(0.98);
            }
        }
::v-deep{
    .el-slider{
        width: 647px;
    }
    .settings-box-radio{
        .editor{
            height: 200px;
        }
    }
    .el-radio-group{
        .el-radio{
            display: block;
            margin-bottom: 20px;
        }
    }
.el-checkbox-group{
    .el-checkbox{
        margin-bottom: 20px;
    }
}
.setting-default-input{
     width: 80px;
    padding-left: 3px;
    .el-input__inner{
        width: 80px!important;
        height: 32px!important;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #e6e6e6;
        
    }
    .el-input__icon{
        line-height: 32px !important;
    }
}
   .is-checked{

    .el-radio__label,.el-checkbox__label{
    position: relative;
    padding-left: 5px;
    color: #333;
    font-weight: 400;
    }
.el-checkbox__label{
    padding-left: 10px;
}
   } 
   .el-checkbox__label{
    span{
        font-size: 14px;
        color: #999;
    }
   }
    .el-radio__label{
font-weight: 400;
    }
}
</style>